// ============================================
// INVOICE BALANCE - one rule, everywhere
// ============================================
// Balance = what the client still owes. A VOIDED, cancelled or fully credited invoice is no longer
// collectable, so its balance is R0 -- NOT "total minus nothing", which is how a voided invoice kept
// showing its full value back at you (INV-00013 still read R6,325 after it was voided).
//
// The same sum was written inline on four screens - the invoice list, the invoice detail, the
// default amount in Record Payment, and the client PDF - and every one of them had the gap. The rule
// lives here so those screens cannot drift apart again.
//
// 'partially_credited' deliberately still computes a balance: part of that invoice is still due.
// ============================================

const NO_BALANCE_STATUSES = ['void', 'cancelled', 'credited'];

// Voided, cancelled or fully credited: there is nothing left to collect.
export const isInvoiceCollectable = (invoice) => {
  const status = String((invoice && invoice.status) || '').toLowerCase();
  return !NO_BALANCE_STATUSES.includes(status);
};

// Voided or cancelled specifically. (A fully credited invoice is collectable-free too, but it is a
// different thing to say to a customer: they were credited, not voided.)
export const isInvoiceVoided = (invoice) => {
  const status = String((invoice && invoice.status) || '').toLowerCase();
  return status === 'void' || status === 'cancelled';
};

export const invoiceBalance = (invoice) => {
  if (!invoice) return 0;
  if (!isInvoiceCollectable(invoice)) return 0;
  const total = parseFloat(invoice.total_amount || 0) || 0;
  const paid = parseFloat(invoice.paid_amount || 0) || 0;
  const credit = parseFloat(invoice.credit_applied || 0) || 0;
  return Math.max(total - paid - credit, 0);
};
